import ComponentStyle from './cms/component/ComponentStyle'
import ComponentBlocksBanner from './cms/component/blocks/ComponentBlocksBanner'
import ComponentBlocksButton from './cms/component/blocks/ComponentBlocksButton'
import ComponentBlocksGallery from './cms/component/blocks/ComponentBlocksGallery'
import ComponentBlocksHeadline from './cms/component/blocks/ComponentBlocksHeadline'
import ComponentBlocksImageWithDescription from './cms/component/blocks/ComponentBlocksImageWithDescription'
import ComponentBlocksSingleImage from './cms/component/blocks/ComponentBlocksSingleImage'
import ComponentBlocksSingleVideo from './cms/component/blocks/ComponentBlocksSingleVideo'
import ComponentBlocksTeaser from './cms/component/blocks/ComponentBlocksTeaser'
import ComponentBlocksText from './cms/component/blocks/ComponentBlocksText'
import ComponentBlocksTextSideBySide from './cms/component/blocks/ComponentBlocksTextSideBySide'
import ComponentBlocksVideoWithDescription from './cms/component/blocks/ComponentBlocksVideoWithDescription'

export default function CmsComponent ({ typename, props, index }) {
  const components = {
    ComponentBlocksBanner,
    ComponentBlocksButton,
    ComponentBlocksGallery,
    ComponentBlocksHeadline,
    ComponentBlocksImageWithDescription,
    ComponentBlocksSingleImage,
    ComponentBlocksSingleVideo,
    ComponentBlocksTeaser,
    ComponentBlocksText,
    ComponentBlocksTextSideBySide,
    ComponentBlocksVideoWithDescription
  }

  const CMSComponent = components[typename]

  if (!CMSComponent) {
    return ''
  }

  return (
    <ComponentStyle
      config={{ ...props }}
      key={index}
    >
      <div className="row">
        <CMSComponent
          {...props}
        />
      </div>
    </ComponentStyle>
  )
}
